import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  listAllTemplatesAction,
  updatePreBuiltTemplatesMappingAction,
} from 'src/modules/SuperAdmin/store/actions/prebuilttemplates.action';
import { showToastError } from 'src/utilities/errortoast';
import * as Yup from 'yup';
import { SuperAdminModal } from '../../../baseComponents';

const EditTemplatesPage = ({
  isOpen,
  setIsOpen,
  selectedPlan,
  selectedTemplates = [],
}) => {
  const dispatch = useDispatch();
  const { allTemplates } = useSelector((state) => state.preBuiltTemplatesState);
  const [templateOptions, setTemplateOptions] = useState([]);

  useEffect(() => {
    dispatch(listAllTemplatesAction());
  }, [dispatch]);

  useEffect(() => {
    if (allTemplates?.length > 0) {
      setTemplateOptions(
        allTemplates.map((template) => ({
          label: template.name,
          value: template.template_id,
        }))
      );
    }
  }, [allTemplates]);

  const initialValues = {
    plan_id: selectedPlan?.plan_id,
    plan_name: selectedPlan?.plan_name,
    templates: selectedTemplates.map((t) => t.template_id),
  };

  const validationSchemaField = Yup.object().shape({
    templates: Yup.array().min(1, 'Templates are required'),
  });

  const sections = [
    {
      heading: 'Edit template mapping',
      fields: [],
    },
    {
      className: 'flex gap-6 item-center',
      fields: [
        {
          name: 'plan',
          type: 'custom',
          className: 'font-normal text-sm items-center justify-center',
          disabled: true,
          render: () => (
            <span className="justify-center">
              <b>Plan name :</b> {initialValues.plan_name}
            </span>
          ),
        },
      ],
    },
    {
      className: 'grid grid-cols-1 gap-8',
      fields: [
        {
          name: 'templates',
          type: 'select',
          title: 'Templates',
          placeholder: 'Select templates',
          options: templateOptions,
          dropdownMode: 'multiple',
          onChange: (setFieldValue, selectedOptions) => {
            setFieldValue('templates', selectedOptions);
          },
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      initialValues={initialValues}
      validationSchema={validationSchemaField}
      closable={true}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      centered={true}
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={(values) => {
        if (values.templates.length === 0) {
          showToastError('Please select at least one template');
          return;
        }
        dispatch(
          updatePreBuiltTemplatesMappingAction(
            initialValues.plan_id,
            values.templates,
            setIsOpen
          )
        );
      }}
    />
  );
};

export default EditTemplatesPage;
